// Traduções desta tela e do diálogo dela — coletadas por glob em core/i18n/messages.ts.
export default {
  pt: {
    'clientesHub.page.title': 'Clientes HUB',
    'clientesHub.page.novo': 'Novo cliente HUB',
    'clientesHub.page.busca': 'Buscar cliente HUB ou cliente do Protheus...',
    'clientesHub.page.col.clienteHub': 'Cliente HUB',
    'clientesHub.page.col.clientes': 'Clientes do Protheus',
    'clientesHub.page.col.quantidade': 'Clientes',
    'clientesHub.page.semCliente': 'Nenhum cliente vinculado',
    'clientesHub.page.vazio': 'Nenhum cliente HUB cadastrado ainda.',
    'clientesHub.page.vazioBusca': 'Nenhum cliente HUB para "{{busca}}".',
    'clientesHub.resumo.clientesHub': 'Clientes HUB',
    'clientesHub.resumo.clientes': 'Clientes do Protheus',
    'clientesHub.resumo.semClienteHub': 'Sem cliente HUB',
    'clientesHub.livres.titulo': 'Clientes do Protheus sem cliente HUB',
    'clientesHub.livres.tudoVinculado': 'Todos os clientes do Protheus já têm cliente HUB.',
    'clientesHub.livres.nenhum': 'Nenhum cliente no cadastro ainda.',
    'clientesHub.dialogo.novo': 'Novo cliente HUB',
    'clientesHub.dialogo.editar': 'Editar cliente HUB',
    'clientesHub.dialogo.nome': 'Nome do cliente HUB',
    'clientesHub.dialogo.nomeDica': 'Como a operação chama o cliente, por exemplo Corteva.',
    'clientesHub.dialogo.nomeObrigatorio': 'Informe o nome do cliente',
    'clientesHub.dialogo.clientes': 'Clientes do Protheus',
    'clientesHub.dialogo.clientesDica': 'Só aparecem os clientes sem cliente HUB e os deste cliente.',
    'clientesHub.dialogo.semOpcoes': 'Nenhum cliente livre',
    'clientesHub.dialogo.escolhidos': 'Clientes escolhidos',
    'clientesHub.dialogo.nenhumEscolhido': 'Nenhum cliente escolhido. O cliente HUB pode ser salvo assim e receber clientes depois.',
    'clientesHub.dialogo.totalClientes': 'Clientes',
    'clientesHub.dialogo.remover': 'Tirar {{nome}} do cliente HUB',
    'clientesHub.dialogo.criado': 'Cliente HUB {{nome}} criado',
    'clientesHub.dialogo.salvo': 'Cliente HUB {{nome}} salvo',
    'clientesHub.apagar.titulo': 'Excluir cliente HUB',
    'clientesHub.apagar.mensagem': 'O cliente HUB {{nome}} sai do cadastro, e os clientes do Protheus dele ficam livres para outro cliente HUB.',
    'clientesHub.apagar.apagado': 'Cliente HUB {{nome}} excluído',
  },
  en: {
    'clientesHub.page.title': 'HUB Customers',
    'clientesHub.page.novo': 'New HUB customer',
    'clientesHub.page.busca': 'Search HUB customer or Protheus customer...',
    'clientesHub.page.col.clienteHub': 'HUB customer',
    'clientesHub.page.col.clientes': 'Protheus customers',
    'clientesHub.page.col.quantidade': 'Customers',
    'clientesHub.page.semCliente': 'No linked customer',
    'clientesHub.page.vazio': 'No HUB customer yet.',
    'clientesHub.page.vazioBusca': 'No HUB customer for "{{busca}}".',
    'clientesHub.resumo.clientesHub': 'HUB customers',
    'clientesHub.resumo.clientes': 'Protheus customers',
    'clientesHub.resumo.semClienteHub': 'Without HUB customer',
    'clientesHub.livres.titulo': 'Protheus customers without a HUB customer',
    'clientesHub.livres.tudoVinculado': 'Every Protheus customer already has a HUB customer.',
    'clientesHub.livres.nenhum': 'No customers registered yet.',
    'clientesHub.dialogo.novo': 'New HUB customer',
    'clientesHub.dialogo.editar': 'Edit HUB customer',
    'clientesHub.dialogo.nome': 'HUB customer name',
    'clientesHub.dialogo.nomeDica': 'What the operation calls the customer, for example Corteva.',
    'clientesHub.dialogo.nomeObrigatorio': 'Enter the customer name',
    'clientesHub.dialogo.clientes': 'Protheus customers',
    'clientesHub.dialogo.clientesDica': 'Only customers without a HUB customer and the ones of this customer are listed.',
    'clientesHub.dialogo.semOpcoes': 'No free customer',
    'clientesHub.dialogo.escolhidos': 'Chosen customers',
    'clientesHub.dialogo.nenhumEscolhido': 'No customer chosen. The HUB customer can be saved like this and receive customers later.',
    'clientesHub.dialogo.totalClientes': 'Customers',
    'clientesHub.dialogo.remover': 'Remove {{nome}} from the HUB customer',
    'clientesHub.dialogo.criado': 'HUB customer {{nome}} created',
    'clientesHub.dialogo.salvo': 'HUB customer {{nome}} saved',
    'clientesHub.apagar.titulo': 'Delete HUB customer',
    'clientesHub.apagar.mensagem': 'The HUB customer {{nome}} leaves the registry, and its Protheus customers become free for another HUB customer.',
    'clientesHub.apagar.apagado': 'HUB customer {{nome}} deleted',
  },
  es: {
    'clientesHub.page.title': 'Clientes HUB',
    'clientesHub.page.novo': 'Nuevo cliente HUB',
    'clientesHub.page.busca': 'Buscar cliente HUB o cliente de Protheus...',
    'clientesHub.page.col.clienteHub': 'Cliente HUB',
    'clientesHub.page.col.clientes': 'Clientes de Protheus',
    'clientesHub.page.col.quantidade': 'Clientes',
    'clientesHub.page.semCliente': 'Ningún cliente vinculado',
    'clientesHub.page.vazio': 'Ningún cliente HUB registrado todavía.',
    'clientesHub.page.vazioBusca': 'Ningún cliente HUB para "{{busca}}".',
    'clientesHub.resumo.clientesHub': 'Clientes HUB',
    'clientesHub.resumo.clientes': 'Clientes de Protheus',
    'clientesHub.resumo.semClienteHub': 'Sin cliente HUB',
    'clientesHub.livres.titulo': 'Clientes de Protheus sin cliente HUB',
    'clientesHub.livres.tudoVinculado': 'Todos los clientes de Protheus ya tienen cliente HUB.',
    'clientesHub.livres.nenhum': 'Ningún cliente registrado todavía.',
    'clientesHub.dialogo.novo': 'Nuevo cliente HUB',
    'clientesHub.dialogo.editar': 'Editar cliente HUB',
    'clientesHub.dialogo.nome': 'Nombre del cliente HUB',
    'clientesHub.dialogo.nomeDica': 'Cómo la operación llama al cliente, por ejemplo Corteva.',
    'clientesHub.dialogo.nomeObrigatorio': 'Informe el nombre del cliente',
    'clientesHub.dialogo.clientes': 'Clientes de Protheus',
    'clientesHub.dialogo.clientesDica': 'Solo aparecen los clientes sin cliente HUB y los de este cliente.',
    'clientesHub.dialogo.semOpcoes': 'Ningún cliente libre',
    'clientesHub.dialogo.escolhidos': 'Clientes elegidos',
    'clientesHub.dialogo.nenhumEscolhido': 'Ningún cliente elegido. El cliente HUB puede guardarse así y recibir clientes después.',
    'clientesHub.dialogo.totalClientes': 'Clientes',
    'clientesHub.dialogo.remover': 'Quitar {{nome}} del cliente HUB',
    'clientesHub.dialogo.criado': 'Cliente HUB {{nome}} creado',
    'clientesHub.dialogo.salvo': 'Cliente HUB {{nome}} guardado',
    'clientesHub.apagar.titulo': 'Eliminar cliente HUB',
    'clientesHub.apagar.mensagem': 'El cliente HUB {{nome}} sale del registro, y sus clientes de Protheus quedan libres para otro cliente HUB.',
    'clientesHub.apagar.apagado': 'Cliente HUB {{nome}} eliminado',
  },
}
